<template>
  <ul class="ml-6 list-disc">
    <li>{{ text('context_info.TEMPLE.p1a') }}</li>
    <li>{{ text('context_info.TEMPLE.p1b') }}</li>
  </ul>
  <hr class="my-4" />
  <ul class="ml-6 list-disc">
    <li>{{ text('context_info.TEMPLE.p2a') }}</li>
    <li>{{ text('context_info.TEMPLE.p2b') }}</li>
    <li>{{ text('context_info.TEMPLE.p2c') }}</li>
    <li>{{ text('context_info.TEMPLE.p2d') }}</li>
  </ul>
  <hr class="my-4" />
  <ul class="ml-6 list-disc">
    <li>{{ text('context_info.TEMPLE.p3a') }}</li>
    <li>{{ text('context_info.TEMPLE.p3b') }}</li>
    <li>{{ text('context_info.TEMPLE.p3c') }}</li>
  </ul>
  <hr class="my-4" />
  <ul>
    <li>*** {{ text('context_info.TEMPLE.p4') }}</li>
  </ul>
</template>

<script setup>
import text from '~/text';
</script>
